(ns app.front.view.group.admin.gis-source-config
  (:require [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.ui.error-boundary :as eb]
            [app.front.ui.radio :as ui-radio]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::gis-source-changed
  (fn [_ [_ group-id data-source]]
    {:comm/command {:command    :domain-group/set-property-data-source
                    :data       (util/mmap group-id data-source)
                    :on-success [::gis-source-changed.success]}}))

(rf/reg-event-fx ::gis-source-changed.success
  (fn [_ [_ status resp]]
    {:dispatch [::entities/apply-changes status resp]}))

(defn view []
  (let [tr       (<sub [::gas/group-tr])
        group-id (<sub [::gas/group-id])]
    [eb/error-boundary
     [:section.rounded.w-full.p-8
      [:h2 (tr [:gis-backend/title])]
      [ui-radio/radio
       {:name       (str group-id "-gis-source-radio")
        :values     group-model/property-data-source-values
        :value      (get (<sub [::entities/entity group-id])
                         :group/property-data-source
                         :gis-backend/remote)
        :label-text (tr [:gis-backend/radio-label])
        :val->str   (comp tr vector)
        :on-change  #(>evt [::gis-source-changed group-id %])}]]]))
